module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-list"
  }, [_c('ul', {
    staticClass: "nav page-content"
  }, _vm._l((_vm.pages), function(page) {
    return (page.listed && page.published) ? _c('li', {
      staticClass: "nav-item",
      attrs: {
        "id": page.slug
      }
    }, [_c('router-link', {
      staticClass: "thumb",
      attrs: {
        "to": '/work/' + page.slug
      }
    }, _vm._l((page.slices), function(slice) {
      return (slice.index < 3) ? _c('div', {
        class: slice.css_class
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(slice.content)
        }
      })]) : _vm._e()
    }))], 1) : _vm._e()
  })), _vm._v(" "), _c('div', {
    attrs: {
      "id": "anchor-nav"
    }
  }, [_c('ul', _vm._l((_vm.pages), function(page) {
    return (page.listed && page.published) ? _c('li', {
      staticClass: "anchor-nav-item"
    }, [_c('a', {
      attrs: {
        "href": '#' + page.slug
      },
      on: {
        "click": function($event) {
          _vm.smoothScrollTo(page.slug)
        }
      }
    }, [_vm._v("\n            " + _vm._s(page.title) + "\n        ")]), _vm._v(" "), _vm._m(0, true)]) : _vm._e()
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48a75bba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/front/PageList.vue
// module id = 260
// module chunks = 1